export default __webpack_public_path__ + "static/media/system_diagram.d0e0c450.jpg";